<template>
  <div>
    <vxe-modal ref="modal" v-model="formVisible" :title="`分批付款明细`" width="90%" height="90%" @show="showModal">
      <div class="formContainer">
        <div class="leftFormContainer">
          <div>
            <div class="title-amount">
              <span>合同金额: {{ form.contract_amount }}元</span>
              <span>{{ amountInCapitalLetters }}</span>
            </div>
            <div class="flex-center">
              <el-button
                :disabled="isDisabled"
                type="text"
                @click="addPaymentDetail"
                circle
                icon="el-icon-plus"
              ></el-button>
              <el-button
                type="text"
                @click="delPaymentDetail"
                circle
                :disabled="isDisabled"
                icon="el-icon-delete"
                style="color: red"
              ></el-button>
            </div>
          </div>
          <div class="table-panel">
            <vxe-grid
              ref="xTable"
              resizable
              :column-config="{ minWidth: '80px' }"
              :data="tableData"
              :showOverflow="true"
              size="mini"
              :edit-config="{ trigger: 'dblclick', mode: 'cell', activeMethod: activeMethod, showIcon: false }"
              :mouse-config="{ area: true }"
              :tooltip-config="{
                showAll: true,
                theme: 'dark'
              }"
              highlight-hover-row
              highlight-current-row
              height="100%"
              :columns="gridColumns"
              :keyboard-config="{
                isArrow: true,
                isEnter: true,
                isTab: true,
                isClip: true,
                enterToTab: true,
                isEdit: true
              }"
              :scroll-y="{
                mode: 'wheel'
              }"
              :edit-rules="verRules"
              @cell-menu="cellContextMenuEvent"
              :cell-style="cellStyle"
              :menu-config="{ body: { options: bodyMenus }, visibleMethod: visibleMethod }"
              show-footer
              :footer-method="footerMethod"
            >
            </vxe-grid>
          </div>
        </div>
        <div class="rightFormContainer">
          <div class="file-container">
            <FileList :ID="id" ref="FileListRef" :is-disabled="isDisabled" vuePath="ContractManagementBatchPayModal" />
          </div>
        </div>
      </div>

      <!-- 页脚按钮 -->
      <div class="operate-area">
        <el-button type="primary" :disabled="isDisabled" @click="save">保存</el-button>
      </div>
    </vxe-modal>
    <!-- 日期输入框 -->
    <DateInput ref="DateInputRef" @sureHandler="sureBackDate" />
  </div>
</template>

<script>
import FileList from '@/components/Form/FileList.vue'
export default {
  name: 'DetailModal',
  components: { FileList },
  data() {
    return {
      id: -1,
      formVisible: false,
      tableData: [],
      gridColumns: [
        { type: 'seq', width: 40, fixed: 'left' },
        { type: 'checkbox', width: 40, fixed: 'left' },
        {
          field: 'batch',
          title: '批次',
          editRender: { name: 'input' },
          slots: {
            header: ({ column }) => {
              return [
                <span>
                  {column.title}
                  &nbsp;
                  <i class='iconfont col-iconfont fjyk-tianxie' />
                </span>
              ]
            }
          }
        },
        {
          field: 'expected_receipt_date',
          title: '预计付款日期',
          formatter: ['formatDate', 'yyyy-MM-dd'],
          editRender: { name: '$input', attrs: { disabled: true } },
          slots: {
            header: ({ column }) => {
              return [
                <span>
                  {column.title}
                  &nbsp;
                  <i class='iconfont col-iconfont fjyk-mouseR' />
                </span>
              ]
            }
          }
        },
        {
          field: 'expected_receipt_amount',
          title: '预计付款金额',
          formatter: ['formatAmount', '2', true],
          editRender: { name: 'input' },
          slots: {
            header: ({ column }) => {
              return [
                <span>
                  {column.title}
                  &nbsp;
                  <i class='iconfont col-iconfont fjyk-tianxie' />
                </span>
              ]
            }
          }
        },
        {
          field: 'receipt_date',
          title: '实际到款日期',
          formatter: ['formatDate', 'yyyy-MM-dd'],
          editRender: { name: '$input', attrs: { disabled: true } },
          slots: {
            header: ({ column }) => {
              return [
                <span>
                  {column.title}
                  &nbsp;
                  <i class='iconfont col-iconfont fjyk-mouseR' />
                </span>
              ]
            }
          }
        },
        {
          field: 'receipt_amount',
          title: '实际付款金额',
          formatter: ['formatAmount', '2', true],
          editRender: { name: 'input' },
          slots: {
            header: ({ column }) => {
              return [
                <span>
                  {column.title}
                  &nbsp;
                  <i class='iconfont col-iconfont fjyk-tianxie' />
                </span>
              ]
            }
          }
        },
        {
          field: 'memo',
          title: '备注',
          editRender: { name: 'input' },
          slots: {
            header: ({ column }) => {
              return [
                <span>
                  {column.title}
                  &nbsp;
                  <i class='iconfont col-iconfont fjyk-tianxie' />
                </span>
              ]
            }
          }
        }
      ],
      // 表单
      form: {
        detailList: [],
        paymentList: [],
        timeLine: [],
        id: 0,
        num: '',
        contract_title: '',
        confirmor: '',
        contract_templates_id: 0,
        contract_template_name: '',
        project_name: '',
        last_modify_time: '',
        content: '',
        creator_id: 0,
        creator: '',
        createTime: '',
        contract_amount: 0
      },
      isChange: false,
      dataBindingComplete: false,
      delPaymentDetailList: [],
      verRules: {
        expected_receipt_date: [{ required: true, message: '请输入预计到款日期', trigger: 'change' }],
        batch: [{ required: true, message: '请输入批次', trigger: 'change' }],
        expected_receipt_amount: [
          { required: true, message: '请输入预计付款金额', trigger: 'change' },
          {
            validator: this.isDecimal,
            validNumerical: this.validNumerical.nonNegative,
            length: 12,
            decimalLength: 2,
            trigger: 'change'
          }
        ],
        receipt_amount: [
          {
            validator: this.isDecimal,
            validNumerical: this.validNumerical.nonNegative,
            length: 12,
            decimalLength: 2,
            trigger: 'change'
          }
        ],
        memo: [
          {
            min: 0,
            max: 2048,
            message: '长度在 0 到 2048 个字符',
            trigger: 'change'
          }
        ]
      },
      // 右键缓存
      areas: {},
      colProperty: '',
      bodyMenus: [[]]
    }
  },
  methods: {
    // 表尾函数
    footerMethod({ columns, data }) {
      const that = this
      const sums = []
      columns.forEach((column, columnIndex) => {
        if (columnIndex === 0) {
          sums.push('合计')
        } else {
          let sumCell = null
          switch (column.property) {
            case 'expected_receipt_amount':
            case 'receipt_amount':
              sumCell = that.$utils.commafy(that.$utils.sum(data, column.property), { digits: 2 })
              break
          }

          sums.push(sumCell)
        }
      })
      // 返回一个二维数组的表尾合计
      return [sums]
    },
    visibleMethod({ options, column }) {
      options.forEach(list => {
        list.forEach(item => {
          if (!column || this.isDisabled) {
            item.visible = false
          } else {
            item.visible = item.code === column.property
          }
        })
      })
      return true
    },
    // 按下右键缓存选中列
    cellContextMenuEvent({ column, row }, event) {
      this.areas = this.$refs.xTable.getCellAreas()
      this.colProperty = column.property

      if (['expected_receipt_date', 'receipt_date'].includes(column.property)) {
        this.$refs.DateInputRef.formVisible = true
      }
    },
    sureBackDate(date) {
      this.areas.forEach(area => {
        for (let row of area.rows) {
          for (let col of area.cols) {
            if (col.property === this.colProperty) {
              row[this.colProperty] = date
            }
          }
        }
      })
    },
    async validEnter() {
      this.removeEmptyForTable(this.$refs.xTable)
      const errMap = await this.$refs.xTable.fullValidate(true).catch(errMap => errMap)
      if (errMap) {
        this.$message.error('验证失败,请核对输入数据')
        return false
      }
      return true
    },
    // 保存
    async save() {
      const flag = await this.validEnter()
      if (flag) {
        const sum = this.tableData.reduce((total, item) => total + Number(item.expected_receipt_amount), 0)
        if (sum.toString() !== this.form.contract_amount.toString()) {
          this.$confirm('预计付款总额与合同金额不同, 是否继续保存?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
            .then(() => {
              this.update()
            })
            .catch(() => {})
        } else {
          this.update()
        }
      }
    },
    // 更新
    async update() {
      this.form.paymentList = [...this.tableData, ...this.delPaymentDetailList]
      const params = { ...this.form }
      const { data: res } = await this.$http.put('/Finance/Contract', params)
      if (res.isSuccess) {
        this.$emit('updateData')
        this.BindText()
        this.$message.success(this.messageConfig.save.success)
      } else {
        this.$message.error(res.errorMessage)
      }
    },
    // 获取数据
    async BindText() {
      this.dataBindingComplete = false
      this.isChange = false
      const { data: res } = await this.$http.get('/Finance/Contract', {
        params: {
          id: this.id
        }
      })
      if (res.isSuccess) {
        this.form = res.data
        this.tableData = this.form.paymentList
      } else {
        this.$message.error(res.errorMessage)
      }
      this.$nextTick(() => {
        this.dataBindingComplete = true
      })
    },
    addPaymentDetail() {
      const params = {
        id: 0,
        batch: '',
        expected_receipt_date: this.ykDateFormat('yyyy-MM-dd', new Date()),
        expected_receipt_amount: 0,
        receipt_date: '1900-01-01',
        receipt_amount: 0
      }
      this.tableData.push(params)
    },
    delPaymentDetail() {
      const checkRecords = this.$refs.xTable.getCheckboxRecords()
      if (checkRecords.length === 0) {
        this.$message.warning('请选择要删除的数据')
        return
      }
      this.$confirm('是否确认删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const delXIDList = checkRecords.map(item => item._XID)
        checkRecords.forEach(item => {
          if (item.id > 0) {
            item.id = 0 - item.id
            this.delPaymentDetailList.push(item)
          }
        })
        this.tableData = this.tableData.filter(item => !delXIDList.includes(item._XID))
      })
    },
    openModal(id = 0) {
      this.id = id
      this.$nextTick(() => {
        this.formVisible = true
      })
    },
    // cell激活控制
    activeMethod({ column }) {
      if (this.isDisabled) {
        return false
      }
      return !(column.editRender && column.editRender.attrs && column.editRender.attrs.disabled === true)
    },
    // 提交缓存文件
    submitCacheFileToServer() {
      this.$refs.FileListRef.handleUploadCacheFileToDB()
    },
    // 获取附件
    getFileList() {
      this.$refs.FileListRef.init()
    },
    showModal() {
      this.BindText()
      this.getFileList()
    },
    // 样式
    cellStyle({ row }) {
      // 不通过
      if (row.expected_receipt_amount > row.receipt_amount) {
        return {
          backgroundColor: '#f56c6c',
          color: '#ffffff'
        }
      } else {
        return {
          backgroundColor: '#2ed573'
        }
      }
    }
  },
  watch: {
    tableData: {
      handler(val) {
        if (this.dataBindingComplete) {
          this.isChange = true
        }
      },
      deep: true
    }
  },
  computed: {
    isDisabled() {
      return this.$store.state.userInfo.name !== '连燕燕'
    },
    amountInCapitalLetters() {
      const amount = this.form.contract_amount
      if (amount == null || amount == '') {
        return ''
      }
      return this.amountLtoU(amount)
    }
  }
}
</script>

<style scoped lang="less">
@rightFormContainerWidth: 250px;

.bottomBtns {
  display: flex;
  justify-content: center;
  margin-top: 10px;
}
.formContainer {
  height: calc(100% - 40px - 10px - 31px);
  display: flex;
  flex-wrap: wrap;
}
.el-form-item {
  // margin: 0px !important;
  width: 100%;
  .el-input,
  .el-select,
  .el-date-picker {
    width: 100%;
  }
}
.leftFormContainer {
  height: 100%;
  width: calc(100% - 350px);
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  padding: 0 10px 10px 10px;
  overflow: auto;
  .table-panel {
    height: 100%;
  }

  /* 修改滚动条的宽度和颜色 */
  &::-webkit-scrollbar {
    width: 10px;
  }

  &::-webkit-scrollbar-track {
    background-color: #f1f1f1;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #999;
  }

  /* 鼠标悬停时滚动条 thumb 的颜色 */
  &::-webkit-scrollbar-thumb:hover {
    background-color: #888;
  }
}
.rightFormContainer {
  height: 100%;
  width: 350px;
  box-sizing: border-box;
  padding: 0 10px;
}
.operate-area {
  display: flex;
  align-items: center;
  justify-content: center;
}
.file-container {
  height: 50%;
}
.timeline {
  height: 50%;
  display: flex;
  flex-direction: column;
  .timeline-panel {
    flex-grow: 1;
    padding: 15px 0;
    border-radius: 10px;
    overflow: auto;
    background-color: #eee;
  }
}
/deep/.el-timeline {
  padding-inline-start: 18px !important;
}
.flex-center {
  display: flex;
  align-items: center;
}
.title-amount {
  font-size: 14px;
  font-weight: 600;
  & span {
    margin-right: 20px;
  }
}
</style>
